import React, { useState, useEffect } from "react";

import {
    Grid,
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
    Typography,
} from "@material-ui/core";

export default (props) => {
    const [points, setPoints] = useState(props.points);

    useEffect(() => {
        setPoints(props.points);
    }, [props.points]);
    return (
        <Grid item xl={12} xs={12}>
            <Typography
                style={{ marginLeft: 24, marginBottom: 30 }}
                variant="h5"
            >
                Talking Points
            </Typography>
            <List style={{ height: "auto" }}>
                {points &&
                    points.map((e, i) => {
                        return (
                            <ListItem
                                style={{
                                    border: "1px solid lightgray",
                                    padding: 6,
                                    marginBottom: 6,
                                    borderRadius: 12,
                                }}
                            >
                                <ListItemIcon>
                                    <Typography align="center">
                                        {i + 1}
                                    </Typography>
                                </ListItemIcon>
                                <ListItemText primary={e} />
                            </ListItem>
                        );
                    })}
            </List>
        </Grid>
    );
};
